// extracted by mini-css-extract-plugin
export var audience = "audience-module--audience--00edd";
export var audienceCard = "audience-module--audienceCard--526ce";
export var audienceContainer = "audience-module--audienceContainer--c620c";
export var audienceWrapper = "audience-module--audienceWrapper--73df8";
export var dark = "audience-module--dark--10ec8";
export var grid = "audience-module--grid--156ce";
export var headline = "audience-module--headline--b91a9";
export var innerGrid = "audience-module--innerGrid--00f68";
export var light = "audience-module--light--bd1e0";